import { Tabs } from "antd"
import React, { useMemo } from "react"
import styles from "./resortApartments.module.scss"
import { YouTube } from "../../YouTube/YouTube"
import { icons } from "./icons"
import { Preview3D } from "../Preview3D"
import { SlideAppear } from "../../Animation/SlideAppear"

const apartmentsNameMap = {
    Studio: "Studio",
    Specialty: "Specialty",
    One_Bedroom: "1 Bedroom",
    Two_Bedroom: "2 Bedroom",
    Grand_Villa: "Grand Villa"
}
const Icon1 = icons[1]
const Icon2 = icons[2]
const Icon3 = icons[3]
const Icon4 = icons[4]
const Icon5 = icons[5]

function TabContent(item) {
    return (
        <section className={styles.tabContent}>
            <div className={styles.tabRowOne}>
                <div className={styles.overStats}>
                    <ul className={styles.list}>
                        <li>
                            <Icon1 />
                            Sleeps {item.sleeps}
                        </li>
                        <li>
                            <Icon2 />{" "}
                            <span className={styles.textEllipsis} title={item.bed_config}>
                                {item.bed_config}
                            </span>
                        </li>
                        <li>
                            <Icon3 /> {item.bathrooms} bathrooms
                        </li>
                        <li>
                            <Icon4 /> {item.sqft} sqft
                        </li>
                        <li>
                            <Icon5 /> {item.units_on_property} units on property
                        </li>
                    </ul>
                </div>
                <YouTube url={item.room_tour} className={styles.youtube} height={265} width={620} />
            </div>
            <div className={styles.over}>
                <Preview3D url={item.tour_3d} preview={item.tour_3d_preview} />
            </div>
        </section>
    )
}

function getTabName(apartment) {
    return apartment?.name || apartmentsNameMap[apartment.type]
}

export function ResortApartments({ resort }) {
    const apartments = resort?.apartments
    const items = useMemo(() => {
        return apartments?.map((item, k) => {
            return {
                label: getTabName(item),
                key: k,
                children: <TabContent {...item} />
            }
        })
    }, [apartments])
    if (!apartments?.length) {
        return null
    }
    return (
        <SlideAppear className={styles.root}>
            <Tabs defaultActiveKey={0} className={styles.tabRoot} items={items} />
        </SlideAppear>
    )
}
